/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Create_BtnInputs */

const vi_order_create_btn = /** @type {(inputs: Order_Create_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo đơn`)
};

/**

* @param {Order_Create_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_create_btn = /** @type {((inputs?: Order_Create_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Create_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_create_btn(inputs)
});